module.exports = __webpack_public_path__ + "img/slider_b01.bc7524a.a25664dd.png";